export default __webpack_public_path__ + "static/media/cardio.2ba9c984.jpg";